import { render, staticRenderFns } from "./Dianwancheng.vue?vue&type=template&id=25e97db7"
import script from "./Dianwancheng.vue?vue&type=script&lang=js"
export * from "./Dianwancheng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports